import { ChangeEvent } from 'react';

import { VerificationScope } from '../../types';
import { getVerificationScopeLabel, getVerificationScopeOptions } from '../../utils/verificationScope';

type VerificationScopeSelectProps = {
  value: VerificationScope;
  onChange: (verificationScope: VerificationScope) => void;
  includeAll?: boolean;
};

function VerificationScopeSelect({ value, onChange, includeAll = true }: VerificationScopeSelectProps) {
  function handleChange(event: ChangeEvent<HTMLSelectElement>) {
    onChange(event.currentTarget.value as VerificationScope);
  }

  return (
    <select
      className="basis-2/3 -mt-1 border border-gray-300 rounded px-3 py-2 bg-white"
      value={value}
      onChange={handleChange}>
      {getVerificationScopeOptions(includeAll).map(option => (
        <option key={option} value={option}>
          {getVerificationScopeLabel(option)}
        </option>
      ))}
    </select>
  );
}

export default VerificationScopeSelect;
